import { processApiFieldErrors } from '../../../utils/processApiFieldErrors'
import { getErrorMessage } from '../../../utils/utils'
import {
  FINDER_BE_TO_FORM_FIELD,
  FINDER_BE_TO_FIELD_TITLE,
} from './finderErrorMaps'

export interface ApplyFinderApiErrorDeps {
  /** Set the inline per-field error map (keyed by form field: positionId/skillLevel/bio/days). */
  setFieldErrors: (errors: Record<string, string>) => void
  /** Summary toast (mobile: an Alert.alert wrapper). */
  notifyError: (message: string) => void
}

/**
 * Translate a thrown finder-preference API error into the Add/Edit sheet's
 * inline field-error map — the finder counterpart of applyFamilyApiError (the
 * sheet is useState-controlled, not Formik). Field-error responses show only
 * inline per-field messages (no summary toast); falls back to a toast (backend
 * .message, then getErrorMessage) when the error carries no mapped
 * invalid_fields.
 */
export const applyFinderApiError = (
  err: unknown,
  deps: ApplyFinderApiErrorDeps
): void => {
  const { setFieldErrors, notifyError } = deps
  const e = err as {
    invalid_fields?: Record<string, string | string[]>
    message?: string
  }

  const { formErrors, titles, hasFieldErrors } = processApiFieldErrors(
    e.invalid_fields,
    {
      fieldMap: FINDER_BE_TO_FORM_FIELD,
      titleMap: FINDER_BE_TO_FIELD_TITLE,
    }
  )

  if (!hasFieldErrors || titles.length === 0) {
    setFieldErrors({})
    notifyError(e.message ?? getErrorMessage(err))
    return
  }

  setFieldErrors(formErrors)
}
